import type { OrgProfileUnavailableReason } from "../../state/orgProfile";
import { Button } from "../ui/button";

const MESSAGES: Record<OrgProfileUnavailableReason, string> = {
  unconfigured:
    "Compliance records are unavailable. Ask your administrator to check the workspace connection.",
  "no-identity": "Sign in with Amoreg to view this organization's compliance records.",
  "idp-unconfigured":
    "The domain API has no identity-provider key, so account-bound records can't be read. Ask your administrator to set WORKOS_API_KEY on the API deployment.",
  error: "Compliance records could not be loaded. Try again in a moment.",
};

/** Failed reads must remain distinguishable from an empty compliance record. */
export function ComplianceUnavailable({
  reason,
  onRetry,
}: {
  readonly reason: OrgProfileUnavailableReason;
  readonly onRetry: () => void;
}) {
  return (
    <div role="alert" className="rounded-xl border border-destructive/20 bg-destructive/5 p-4">
      <p className="text-sm text-foreground">{MESSAGES[reason]}</p>
      <Button size="sm" variant="outline" className="mt-3" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}

export function ComplianceOrganizationMissing() {
  return (
    <p
      role="status"
      className="rounded-xl border border-dashed border-border/60 px-6 py-10 text-center text-sm text-muted-foreground"
    >
      Select an organization to review its compliance records.
    </p>
  );
}
